import { Alert, Button } from "@e-seikatsu/design-system";
import {
  Box,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  Stack,
  Typography,
} from "@mui/material";
import { textSx, OpenInNewLink } from "esa-components";
import type { JSX } from "react";
import { SUPPORT_SITE_PAGES } from "const/supportSite";

export type TermsOfServiceDialogProps = {
  open: boolean;
  onSubmit: () => Promise<void>;
  isLoggedIn?: boolean;
};

const TermsOfServiceDialog = ({
  open,
  onSubmit,
  isLoggedIn = false,
}: TermsOfServiceDialogProps): JSX.Element => (
  <Box>
    <Dialog fullWidth open={open}>
      <DialogTitle>利用規約改定のお知らせ</DialogTitle>
      <DialogContent>
        <Stack
          spacing={2}
          sx={{
            pt: 2,
          }}
        >
          <Stack>
            <Typography variant="subtitle2">
              いい生活アカウントをご利用いただきありがとうございます。
            </Typography>
            <Typography variant="subtitle2">
              2026年2月24日付で「いい生活Square 利用規約」を改定しました。
            </Typography>
          </Stack>
          <Alert color="info">
            <Stack spacing={0.5}>
              <Typography
                variant="subtitle1"
                sx={{
                  fontWeight: "bold",
                }}
              >
                主な改定内容
              </Typography>
              <Typography>・新オプションの利用条件を追加</Typography>
              <Typography>・サービス共通の利用条件を集約</Typography>
            </Stack>
          </Alert>
          <Typography sx={{ ...textSx.sm, ...textSx.secondaryText }}>
            上記改定の詳細については、こちらの新しい利用規約（
            <OpenInNewLink href={SUPPORT_SITE_PAGES.squareTerms}>
              いい生活Square
            </OpenInNewLink>
            ）をご確認ください。
          </Typography>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button
          type="button"
          onClick={() => void onSubmit()}
          variant="contained"
        >
          {isLoggedIn
            ? "利用規約に同意して続ける"
            : "利用規約に同意してログイン"}
        </Button>
      </DialogActions>
    </Dialog>
  </Box>
);

export default TermsOfServiceDialog;
